<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">ออกงานเรียบร้อยแล้ว</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_summarize_add === true">สรุปการออกงานเรียบร้อยแล้ว</v-alert>
    </v-slide-x-reverse-transition>
    <h2>วันที่ {{ date }} น.</h2>
    <v-card>
        <div class="mb-2">
            <v-tabs grow>
                <v-tab @click="page(title_detail.shifts_id)" v-for="(title_detail,index) in title_list" :key="index">{{ title_detail.shift_name }}</v-tab>
            </v-tabs>
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false">
                <div v-for="(detail_shift,index) in data" :key="index">
                    <v-simple-table v-if="title_type_timework == detail_shift.shifts_id">
                        <thead>
                            <tr>
                                <th class="text-center border_out_time_work_list">
                                    #
                                </th>
                                <th class="text-center border_out_time_work_list">
                                    ชื่อพนักงาน
                                </th>
                                <th class="text-center border_out_time_work_list">
                                    เวลาเข้างาน
                                </th>
                                <th class="text-center border_out_time_work_list">
                                    การออกงาน
                                </th>
                                <th class="text-center border_out_time_work_list">
                                    OT (ชั่วโมง)
                                </th>
                            </tr>
                        </thead>
                        <tbody v-for="(detail_employee,index_employee) in detail_shift.employee" :key="index_employee">
                            <tr>
                                <td class="text-center border_out_time_work_list">
                                    <div class="pa-2">
                                        {{ index_employee + 1 }}
                                    </div>

                                </td>
                                <td class="text-center border_out_time_work_list">
                                    <div class="pa-2">
                                        {{ detail_employee.employee_name }}
                                    </div>

                                </td>
                                <td class="text-center border_out_time_work_list">
                                    <div class="pa-2">
                                        {{ detail_employee.start_work ? detail_employee.start_work : '-' }}
                                    </div>

                                </td>
                                <td class="text-center border_out_time_work_list" width="20%">
                                    <div class="pa-2" v-if="detail_employee.start_work && !detail_employee.out_work">
                                        <v-btn color="error" class="white--text" @click="openOutWork(detail_shift.shift_name,detail_employee.work_time_id,detail_employee.employee_name)">
                                            ลงเวลาออกงาน
                                        </v-btn>
                                    </div>
                                    <div class="pa-2" v-if="detail_employee.start_work && detail_employee.out_work">
                                        {{ detail_employee.out_work}}
                                    </div>
                                    <div class="pa-2" v-if="!detail_employee.start_work && !detail_employee.out_work">
                                        -
                                    </div>

                                </td>
                                <td class="text-center border_out_time_work_list" width="20%">
                                    <div class="pa-2">
                                        <v-text-field type="number" v-model="detail_employee.ot" hide-details="auto" dense outlined></v-text-field>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </div>
        </div>
    </v-card>
    <div>
        <v-btn width="100%" height="50" @click="workTimeOutUpdate()">สรุปงาน</v-btn>
    </div>
    <v-dialog v-model="open_out_work" persistent max-width="600">
        <v-card>
            <v-card-title>
                {{ shift_name }}
            </v-card-title>

            <v-card-text>
                {{ employee_name }} ออกงานใช่หรือไม่ ?
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" @click="outWork()">
                    ตกลง
                </v-btn>
                <v-btn color="error" @click="open_out_work = false">
                    ยกเลิก
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import outtimework from '@/api/team/teaminouttimework/outtimework.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_add: false,
            alert_show_summarize_add: false,
            open_out_work: false,
            interval: null,
            date: Intl.DateTimeFormat('th-TH', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            }).format(),
            shift_name: null,
            work_time_id: null,
            employee_name: null,
            title_type_timework: null,
            title_list: [],
            data: [],
        }
    },
    methods: {
        async outTimeWorkList() {
            this.loading_page = true
            this.title_list = []
            this.data = []
            outtimework.outTimeWorkList().then((response) => {
                if (response.data.successful === true) {
                    response.data.workShifts.forEach((detail, index) => {
                        if (index == 0 && this.title_type_timework == null) {
                            this.title_type_timework = detail.shifts_id
                        }
                        this.title_list.push({
                            shifts_id: detail.shifts_id,
                            shift_name: detail.shift_name,
                        })
                    })

                    this.data = response.data.workShifts
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async page(type) {
            this.title_type_timework = type
        },
        async openOutWork(shift_name, work_time_id, employee_name) {
            this.shift_name = shift_name
            this.work_time_id = work_time_id
            this.employee_name = employee_name
            this.open_out_work = true
        },
        async outWork() {
            this.loading_page = true
            this.open_out_work = false
            const data = {
                end_date: Intl.DateTimeFormat('th-TH', {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                }).format()
            }
            outtimework.outWork(this.work_time_id, data).then((response) => {
                if (response.data.successful === true) {
                    this.outTimeWorkList()
                    this.shift_name = null
                    this.work_time_id = null
                    this.employee_name = null
                    this.alert_show_add = true
                    setTimeout(() => this.alert_show_add = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async workTimeOutUpdate() {
            this.loading_page = true
            let work_time_id = []
            let work_type = []
            let ot = []
            this.data.forEach((detail_shifts) => {
                detail_shifts.employee.forEach((detail_employee) => {
                    let ot_employee = detail_employee.ot
                    if (ot_employee == '') {
                        ot_employee = null
                    }
                    work_time_id.push(detail_employee.work_time_id)
                    work_type.push(detail_employee.work_type)
                    ot.push(ot_employee)
                })
            })
            const data = {
                work_time_id: work_time_id,
                work_type: work_type,
                ot: ot,
            }
            outtimework.workTimeOutUpdate(data).then((response) => {
                if (response.data.successful === true) {
                    this.outTimeWorkList()
                    this.alert_show_summarize_add = true
                    setTimeout(() => this.alert_show_summarize_add = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    mounted() {
        this.outTimeWorkList()
        this.interval = setInterval(() => {
            this.date = Intl.DateTimeFormat('th-TH', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            }).format()
        }, 1000)
    }
}
</script>

<style scoped>
.border_out_time_work_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
